export function todayISO(): string {
  const date = new Date();
  return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
}
export function validDate(value: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const date = new Date(`${value}T12:00:00Z`);
  return !Number.isNaN(date.getTime()) && date.toISOString().slice(0,10) === value;
}
export function addDays(iso: string | null | undefined, days: number): string {
  if (!iso || !validDate(iso) || !Number.isFinite(days)) return '';
  const date = new Date(`${iso}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate()+days);
  return date.toISOString().slice(0,10);
}
export function daysBetween(a: string,b: string): number { return Math.round((Date.parse(`${b}T12:00:00Z`)-Date.parse(`${a}T12:00:00Z`))/86400000); }
export function fmtDateWritten(iso?: string | null): string {
  if(!iso || !validDate(iso)) return '—';
  return new Intl.DateTimeFormat('es-PA',{day:'numeric',month:'long',year:'numeric',timeZone:'UTC'}).format(new Date(`${iso}T12:00:00Z`)).replace(/ de (\d{4})$/, ' del $1');
}
export const fmtDate = fmtDateWritten;
export function fmtDateLong(iso: string): string {
  if(!validDate(iso)) return '—';
  return new Intl.DateTimeFormat('es-PA',{weekday:'long',day:'numeric',month:'long',year:'numeric',timeZone:'UTC'}).format(new Date(`${iso}T12:00:00Z`)).replace(/ de (\d{4})$/, ' del $1');
}
export function fmtDateMonthDay(iso: string): string { return validDate(iso)?new Intl.DateTimeFormat('es-PA',{weekday:'long',day:'numeric',month:'long',timeZone:'UTC'}).format(new Date(`${iso}T12:00:00Z`)):'—'; }
export function ageStr(iso?: string | null): string {
  if(!iso || !validDate(iso)) return '—';
  const days=daysBetween(iso,todayISO());
  if(days<0) return '—';
  const years=days/365.25, wholeYears=Math.floor(years), months=Math.floor((years-wholeYears)*12);
  return wholeYears<1?`${months} m`:`${wholeYears}a ${months}m`;
}
export function uid(prefix: string): string { return `${prefix}_${crypto.randomUUID()}`; }
